import { z } from 'zod';
export const getOrgMemberCountsRequestParamsSchema = z.object({});
export const organizationMembershipSchema = z.object({
    pendingMemberships: z.number(),
    path: z.string(),
});
export const organizationMembershipMapSchema = z.record(z.string(), organizationMembershipSchema);
export const getOrgMemberCountsResponseSchema = z.object({
    totalMemberCount: z.number(),
    organizationMembershipMap: organizationMembershipMapSchema,
});
